export const initialToggleObj = {
    patient_evaluation: false,
    pain: false,
    mental_health: false,
    special: false,
    agreement: false,
}